import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Interfaccia per i dati dei frazioni
interface Frazione {
    id: number;
    comuneIstat: string;
    comune: string | null;
    provincia: string | null;
    frazione: string;
    seoString: string | null;
}

// Funzione hook per recuperare i frazioni
export const useGetFrazioni = (comuneIstat: string) => {
    const [frazioni, setFrazioni] = useState<Frazione[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchFrazioni = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/frazioni`, { comuneIstat });
                setFrazioni(response.data);
                setLoading(false);
            } catch (error) {
                setError("Impossibile recuperare i frazioni");
                setLoading(false);
            }
        };
        fetchFrazioni();
    }, [comuneIstat]);

    return { frazioni, loading, error };
}

export default useGetFrazioni;